import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ListItemIcon, ListItemText } from '@mui/material';
import { MenuItem } from './types';
import { ScrollableList, SelectedItem, DrawerItem } from './styledComponents';

const MenuList: React.FC<{
  menuItems: MenuItem[];
  selectedItem: number | null;
  onItemClick: (item: MenuItem, index: number) => void;
}> = ({ menuItems, selectedItem, onItemClick }) => (
  <ScrollableList>
    {menuItems.map((item, index) => {
      const ItemComponent = selectedItem === index ? SelectedItem : DrawerItem;
      return (
        <ItemComponent
          key={index}
          component={RouterLink}
          //to={item.url}
          onClick={() => onItemClick(item, index)}
          // 👇 Cast to avoid TS complaining about 'to'
          {...({} as any)}
        >
          {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
          <ListItemText primary={item.name} />
        </ItemComponent>
      );
    })}
  </ScrollableList>
);

export default MenuList;
